var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrid8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 22.75H9C3.57 22.75 1.25 20.43 1.25 15V9C1.25 3.57 3.57 1.25 9 1.25H15C20.43 1.25 22.75 3.57 22.75 9V15C22.75 20.43 20.43 22.75 15 22.75ZM9 2.75C4.39 2.75 2.75 4.39 2.75 9V15C2.75 19.61 4.39 21.25 9 21.25H15C19.61 21.25 21.25 19.61 21.25 15V9C21.25 4.39 19.61 2.75 15 2.75H9Z",
    fill: "currentcolor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 12.75H2C1.59 12.75 1.25 12.41 1.25 12C1.25 11.59 1.59 11.25 2 11.25H22C22.41 11.25 22.75 11.59 22.75 12C22.75 12.41 22.41 12.75 22 12.75Z",
    fill: "currentcolor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 22.25C7.84 22.25 7.5 21.91 7.5 21.5V12C7.5 11.59 7.84 11.25 8.25 11.25C8.66 11.25 9 11.59 9 12V21.5C9 21.91 8.66 22.25 8.25 22.25Z",
    fill: "currentcolor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 22.75C15.34 22.75 15 22.41 15 22V12C15 11.59 15.34 11.25 15.75 11.25C16.16 11.25 16.5 11.59 16.5 12V22C16.5 22.41 16.16 22.75 15.75 22.75Z",
    fill: "currentcolor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 12.75C7.84 12.75 7.5 12.41 7.5 12V2C7.5 1.59 7.84 1.25 8.25 1.25C8.66 1.25 9 1.59 9 2V12C9 12.41 8.66 12.75 8.25 12.75Z",
    fill: "currentcolor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 12.75C15.34 12.75 15 12.41 15 12V2.54001C15 2.13001 15.34 1.79001 15.75 1.79001C16.16 1.79001 16.5 2.13001 16.5 2.54001V12C16.5 12.41 16.16 12.75 15.75 12.75Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid8);
export default __webpack_public_path__ + "static/media/grid-8.d78da98b06a92a43b68d8101644c3bc9.svg";
export { ForwardRef as ReactComponent };